/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
import { AdPassengerRowCustomerFragmentDoc } from '../components/AdPassengerRow/AdPassengerRow.hook'
export type GetPassengersWaypointFragment = {
  __typename?: 'FccWaypoint'
  fccStop: {
    __typename?: 'FccStop'
    id: string | null
    names: Partial<Record<'de' | 'en' | 'no', string>>
  } | null
  stopWithServiceArea: {
    __typename?: 'Stop'
    id: string
    serviceArea: { __typename?: 'ServiceArea'; id: string }
  } | null
  actions: Array<
    | {
        __typename: 'FccWaypointDeliveryAction'
        id: string
        estimatedAt: string
        pickedUpAt: string | null
        trip: { __typename?: 'Trip'; id: string } | null
        customer: {
          __typename?: 'Customer'
          firstName: string | null
          lastName: string | null
          extendedWalkingTime: boolean
          visualImpairment: boolean | null
        } | null
        ridePassengerInfo: {
          __typename?: 'FccRidePassengerInfo'
          customerId: string | null
          displayName: string | null
          boardingRequirements: {
            __typename?: 'FccBoardingRequirements'
            headCount: number
            childSeat: boolean
            wheelchair: boolean
          } | null
          impairments: { __typename?: 'FccImpairments'; visual: boolean } | null
        } | null
      }
    | { __typename?: 'FccWaypointHubReturnAction' }
    | {
        __typename: 'FccWaypointPickupAction'
        id: string
        estimatedAt: string
        pickedUpAt: string | null
        adPassengerAuthenticationState: Types.FccPassengerAuthenticationState | null
        notShownUpAt: string | null
        tripIsCancelled: boolean | null
        trip: { __typename?: 'Trip'; id: string } | null
        customer: {
          __typename?: 'Customer'
          firstName: string | null
          lastName: string | null
          extendedWalkingTime: boolean
          visualImpairment: boolean | null
        } | null
        ridePassengerInfo: {
          __typename?: 'FccRidePassengerInfo'
          customerId: string | null
          displayName: string | null
          boardingRequirements: {
            __typename?: 'FccBoardingRequirements'
            headCount: number
            childSeat: boolean
            wheelchair: boolean
          } | null
          impairments: { __typename?: 'FccImpairments'; visual: boolean } | null
        } | null
      }
    | { __typename?: 'FccWaypointReallocationAction' }
  >
}

export type GetPassengersPickupActionFragment = {
  __typename: 'FccWaypointPickupAction'
  id: string
  estimatedAt: string
  pickedUpAt: string | null
  adPassengerAuthenticationState: Types.FccPassengerAuthenticationState | null
  notShownUpAt: string | null
  tripIsCancelled: boolean | null
  trip: { __typename?: 'Trip'; id: string } | null
  customer: {
    __typename?: 'Customer'
    firstName: string | null
    lastName: string | null
    extendedWalkingTime: boolean
    visualImpairment: boolean | null
  } | null
  ridePassengerInfo: {
    __typename?: 'FccRidePassengerInfo'
    customerId: string | null
    displayName: string | null
    boardingRequirements: {
      __typename?: 'FccBoardingRequirements'
      headCount: number
      childSeat: boolean
      wheelchair: boolean
    } | null
    impairments: { __typename?: 'FccImpairments'; visual: boolean } | null
  } | null
}

export type GetPassengersDeliveryActionFragment = {
  __typename: 'FccWaypointDeliveryAction'
  id: string
  estimatedAt: string
  pickedUpAt: string | null
  trip: { __typename?: 'Trip'; id: string } | null
  customer: {
    __typename?: 'Customer'
    firstName: string | null
    lastName: string | null
    extendedWalkingTime: boolean
    visualImpairment: boolean | null
  } | null
  ridePassengerInfo: {
    __typename?: 'FccRidePassengerInfo'
    customerId: string | null
    displayName: string | null
    boardingRequirements: {
      __typename?: 'FccBoardingRequirements'
      headCount: number
      childSeat: boolean
      wheelchair: boolean
    } | null
    impairments: { __typename?: 'FccImpairments'; visual: boolean } | null
  } | null
}

export const GetPassengersPickupActionFragmentDoc = gql`
    fragment GetPassengersPickupAction on FccWaypointPickupAction {
  __typename
  id
  estimatedAt
  pickedUpAt
  adPassengerAuthenticationState
  notShownUpAt
  tripIsCancelled
  trip {
    id
  }
  customer {
    ...AdPassengerRowCustomer
  }
  ridePassengerInfo {
    customerId
    displayName
    boardingRequirements {
      headCount
      childSeat
      wheelchair
    }
    impairments {
      visual
    }
  }
}
    ${AdPassengerRowCustomerFragmentDoc}`
export const GetPassengersDeliveryActionFragmentDoc = gql`
    fragment GetPassengersDeliveryAction on FccWaypointDeliveryAction {
  __typename
  id
  estimatedAt
  pickedUpAt
  trip {
    id
  }
  customer {
    ...AdPassengerRowCustomer
  }
  ridePassengerInfo {
    customerId
    displayName
    boardingRequirements {
      headCount
      childSeat
      wheelchair
    }
    impairments {
      visual
    }
  }
}
    ${AdPassengerRowCustomerFragmentDoc}`
export const GetPassengersWaypointFragmentDoc = gql`
    fragment GetPassengersWaypoint on FccWaypoint {
  fccStop {
    id
    names
  }
  stopWithServiceArea: stop {
    id
    serviceArea {
      id
    }
  }
  actions {
    ... on FccWaypointPickupAction {
      ...GetPassengersPickupAction
    }
    ... on FccWaypointDeliveryAction {
      ...GetPassengersDeliveryAction
    }
  }
}
    ${GetPassengersPickupActionFragmentDoc}
${GetPassengersDeliveryActionFragmentDoc}`
